import { Button, Grid, Typography, MenuItem, FormControlLabel, Radio, InputAdornment } from '@mui/material';
import { Form, Field, useFormikContext } from 'formik';
import { RadioGroup, TextField } from 'formik-mui';
import { applicationContext } from 'helpers/services';
import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { countryContext, countrySchema } from '../CountryDetailsContext';
import *as yup from 'yup';

let CountryForm = () => {
    let router = useLocation();
    let service = useContext(countryContext);
    let appService = useContext(applicationContext);

    type Country = yup.InferType<typeof countrySchema>;
    let form = useFormikContext<Country>();

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'New country' : `Edit country`;

    return (
        <Form>
            <Grid container spacing={2}>
                <Grid item xs>
                    <Typography variant="h4">{title}</Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant="outlined"
                        color="primary"
                        component={Link}
                        to={'/admin/country'}
                        disabled={service.isSaving}
                    >
                        Cancel
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={service.isSaving}
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Field
                        component={TextField}
                        name="code"
                        label="Code"
                        disabled={isNew === false}
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item xs={6}>
                    <Field
                        component={TextField}
                        name="name"
                        label="Name"
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item xs={4}>
                    <Field
                        component={TextField}
                        name="currencyCode"
                        label="Currency Code"
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item xs={4}>
                    <Field
                        component={TextField}
                        name="currencySymbol"
                        label="Currency symbol"
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item xs={4}>
                    <Field
                        component={TextField}
                        name="currencyDecimal"
                        label="Currency decimal"
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="locales"
                        label="Locale"
                        fullWidth
                        margin="dense"
                        size='small'
                        select
                        SelectProps={{
                            multiple: true
                        }}
                    >
                        {appService.referenceData.Locale.map((locale) =>
                            <MenuItem key={locale.key} value={locale.key}>{locale.value}</MenuItem>
                        )}
                    </Field>
                </Grid>
                <Grid item>
                    <Field
                        component={RadioGroup}
                        name="overrideTaxRate"
                        label="Override tax rate"
                        row
                        onChange={(e: any) => {
                            if (e.target.value === 'false')
                                form.setFieldValue('taxRateOverride', '')

                            form.setFieldValue('overrideTaxRate', e.target.value === 'true' ? true : false)
                        }}
                    >
                        <FormControlLabel
                            value={false}
                            control={<Radio color="primary" />}
                            label='Use default tax rate'
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            value={true}
                            control={<Radio color="primary" />}
                            label='Override tax rate'
                            labelPlacement="end"
                        />
                    </Field>
                </Grid>
                {form.values.overrideTaxRate === true &&
                    <Grid item xs>
                        <Field
                            component={TextField}
                            name="taxRateOverride"
                            label="Override value"
                            type='number'
                            fullWidth
                            margin="dense"
                            size='small'
                            InputProps={{
                                sx: { paddingRight: 0.5 },
                                endAdornment: (
                                    <InputAdornment position="end">%</InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                }
            </Grid>
        </Form>
    );
}

export default CountryForm;